export const DATE_TIME_FORMAT = "DD-MM-YYYY, HH:mm:ss";
export const STATION_A_ID = 1;
export const STATION_B_ID = 3;
